import { render } from "./ShiftAssignModal.vue?vue&type=template&id=8a408bf6"
import script from "./ShiftAssignModal.vue?vue&type=script&lang=js"
export * from "./ShiftAssignModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__